import { Handle } from 'reactflow';

export const BaseNode = ({
  label,
  color = '#6366f1',
  handles = [],
  children,
  width = 220,
  minHeight,
}) => {
  const nodeStyle = {
    width,
    minHeight: minHeight || 'auto',
    background: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: 10,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    fontFamily: '"Inter", "Segoe UI", sans-serif',
    fontSize: 12,
    overflow: 'visible',  
    position: 'relative',  
  };

  const headerStyle = {
    background: color,
    borderRadius: '9px 9px 0 0',
    padding: '7px 12px',
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  };

  const dotStyle = {
    width: 8,
    height: 8,
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.55)',
  };

  const bodyStyle = {
    padding: '10px 12px 12px',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  };

  return (
    <div style={nodeStyle}>
      {/* Header */}
      <div style={headerStyle}>
        <span style={dotStyle} />
        <span style={{ color: '#fff', fontWeight: 600, fontSize: 11, letterSpacing: '0.04em' }}>
          {label}
        </span>
      </div>

      {/* Body */}
      <div style={bodyStyle}>{children}</div>

      {/* Handles */}
      {handles.map((h) => (
        <Handle
          key={h.id}
          type={h.type}
          position={h.position}
          id={h.id}
          className="custom-flow-handle"
          style={{
            width: 10,
            height: 10,
            background: color,
            border: '2px solid #fff',
            boxShadow: '0 0 0 1px ' + color,
            ...h.style,
          }}
        />
      ))}
    </div>
  );
};

// Reusable field components for node bodies

const labelStyle = {
  fontSize: 10,
  fontWeight: 600,
  color: '#64748b',
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  marginBottom: 2,
};

const inputStyle = {
  width: '100%',
  padding: '5px 8px',
  border: '1px solid #e2e8f0',
  borderRadius: 5,
  fontSize: 12,
  color: '#1e293b',
  background: '#f8fafc',
  outline: 'none',
  boxSizing: 'border-box',
};

const selectStyle = {
  ...inputStyle,
  cursor: 'pointer',
};

export const NodeField = ({ label, children }) => (
  <div>
    <div style={labelStyle}>{label}</div>
    {children}
  </div>
);

export const NodeInput = (props) => (
  <input className="nodrag" style={inputStyle} {...props} />
);

export const NodeSelect = ({ children, ...props }) => (
  <select className="nodrag" style={selectStyle} {...props}>
    {children}
  </select>
);

export const NodeTextarea = ({ style, ...props }) => (
  <textarea
    className="nodrag"
    style={{ ...inputStyle, resize: 'none', lineHeight: 1.5, ...style }}
    {...props}
  />
);